import React, { useState } from "react";
import List from '../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import ToolBar from "../../../Common/Toolbar";
import { useHistory } from "react-router-dom";
import StadisticCard from "./StadisticCard";
import CLabel from "../../../Common/CLabel"
import ListPagination from "../../../Templates/List/ListPagination";
import { getGlobalMessageLayout, isNullOrEmpty } from "../../../../common/Helpers";
import { ActionButton, css, Icon, mergeStyleSets, SpinnerSize, TooltipHost, TooltipOverflowMode } from "@fluentui/react";
import { getHomeStadisticExcelData } from "../../../../services/sBook/book.service";
import { Dropdown } from '@fluentui/react';
import { getMessageTreeByObjectByPartyLength } from "../../../../services/sBook/message.service";
import { __enum_SystemPages, __SystemPagesPaths } from "../../../../common/Dictionaries";
import Loading from "../../../Templates/Site/Loading";
import ToolBarDownFall from "../ToolbarDownFall";
import SidePanelSections from '../V3/BookBox/SidePanelSections';
import SidePanelPartys from "../V3/BookBox/SidePanelPartys";
import SidePanelViewUsers from "../SidePanelViewUsers";


function HomeBookListBox(props) {
    const { t } = useTranslation();
    const history = useHistory();

    //Parametros de entrada.

    const inputParam_BookList = props.bookList !== null && props.bookList !== undefined ? props.bookList: null;
    const inputParam_SetBookList = props.setBookList !== null && props.setBookList !== undefined ? props.setBookList : null;
    const inputParam_SecurityProps = props.securityProps !== null && props.securityProps !== undefined ? props.securityProps : null;
    const inputParam_SetShowFilters = props.setterShowFilters !== null && props.setterShowFilters !== undefined ? props.setterShowFilters : null;
    const inputParam_ShowFilters = props.showFilters !== null && props.showFilters !== undefined ? props.showFilters : false;
    const inputParam_ShowFilterButton = props.showFilterButton !== null && props.showFilterButton !== undefined ? props.showFilterButton : false;
    const inputParam_UserName = props.userName !== null && props.userName !== undefined ? props.userName : null;
    //const inputParam_ContractCode = props.contractCode !== null && props.contractCode !== undefined ? props.contractCode : null;
    const inputParam_SelectedStatusFilter = props.selectedStatusFilter !== null && props.selectedStatusFilter !== undefined ? props.selectedStatusFilter : null;
    const inputParam_SetSelectedStatusFilter = props.setSelectedStatusFilter !== null && props.setSelectedStatusFilter !== undefined ? props.setSelectedStatusFilter : null;
    const inputParam_ForceSearchParent = props.forceSearchParent !== null && props.forceSearchParent !== undefined ? props.forceSearchParent : null;
    const inputParam_FilterStartDate = props.filterStartDate !== null && props.filterStartDate !== undefined ? props.filterStartDate : null;
    const inputParam_FilterEndDate = props.filterEndDate !== null && props.filterEndDate !== undefined ? props.filterEndDate : null;
    
    const [length, setLength] = useState(3);
    const [isPanelViewPartysOpen, setIsPanelViewPartysOpen] = useState(false);
    const [isPanelViewSectionsOpen, setIsPanelViewSectionsOpen] = useState(false);
    const [isPanelViewUsersOpen, setIsPanelViewUsersOpen] = useState(false);
    const [objBookSelectedToOptions, setObjBookSelectedToOptions] = useState(null);

    const onViewMessagesClick = (item) => {
        let pathname = null;

        if (item.statusId === 1 || item.statusId === 4) {
            /*history.push({
                pathname: `${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/${ item.id }`,
            })*/
            pathname = `${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/${ item.id }`;
        }
        else {
            //[#NEW31082026#]SE COMENTA POR QUE LAS OTRAS VERSIONES TIENEN PROBLEMAS.
            const userLayoutVersion = "V3"//getGlobalMessageLayout()

            if (userLayoutVersion === "V1") {
                /*history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.Book].text}/${ item.id }`,
                })*/
               pathname = `${__SystemPagesPaths[__enum_SystemPages.Book].text}/${ item.id }`
            }
            else if (userLayoutVersion === "V2") {
                /*history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/${ item.id }`,
                })*/
               pathname = `${__SystemPagesPaths[__enum_SystemPages.BookV2].text}/${ item.id }`
            }
            else if (userLayoutVersion === "V3") {
                /*history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ item.id }`,
                })*/
               pathname = `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ item.id }`
            }
            else {
                /*history.push({
                    pathname: `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ item.id }`,
                })*/
               pathname = `${__SystemPagesPaths[__enum_SystemPages.BookV3].text}/${ item.id }`
            }
        }

        window.open(pathname, '_blank', 'noopener,noreferrer');
    };
    const onViewBookConfig = (e, objBook) => {
        window.open(`${__SystemPagesPaths[__enum_SystemPages.BookCreation].text}/${ objBook.id }`, '_blank', 'noopener,noreferrer');
    };
    const onViewPartys = (e, objBook) => {
        setObjBookSelectedToOptions(objBook)
        setIsPanelViewPartysOpen(true);
    };
    const onViewSections = (e, objBook) => {
        setObjBookSelectedToOptions(objBook)
        setIsPanelViewSectionsOpen(true);
    };
    const onViewUsers = (e, objBook) => {
        setObjBookSelectedToOptions(objBook)
        setIsPanelViewUsersOpen(true);
    };
    const handleExport = (handleDownload, listField) => {  
        getHomeStadisticExcelData(inputParam_FilterStartDate, inputParam_FilterEndDate, inputParam_SelectedStatusFilter).then((serviceResponse) => {
            handleDownload(serviceResponse.data, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,");
        });
    };
    const onAddBook = () => {
        history.push({
            pathname: __SystemPagesPaths[__enum_SystemPages.BookCreation].text
        })
    };
    const onShowFilters = () => {
        inputParam_SetShowFilters && inputParam_SetShowFilters(!inputParam_ShowFilters);
    };
    const onLengthChange = (value) => {
        setLength(parseInt(value.currentTarget.textContent))
    };
    const searchMoreItems = () => {
        let item = document.getElementsByClassName("itemHtmlClassName");
        let itemBtnClearID = document.getElementById("btnClearID");

        getMessageTreeByObjectByPartyLength(inputParam_UserName, length).then((serviceResponse) => {

            inputParam_BookList.data.forEach(element => {
                serviceResponse.data.data.forEach(elementWmessages => {
                    if (element.bookCode === elementWmessages.bookCode) {
                        element.l_mensajes = elementWmessages.l_mensajes;
                    }
                });
            });
    
            inputParam_SetBookList && inputParam_SetBookList(inputParam_BookList)
        });

        Array.prototype.forEach.call(item, function(el) {
            el.style.display = "block";
        });

        itemBtnClearID.style.display = "block";
    };
    const showHideMoreItems = () => {
        let item = document.getElementsByClassName("itemHtmlClassName");
        
        Array.prototype.forEach.call(item, function(el) {

            const isHiddenItem = el.style.display === "none";

            if (isHiddenItem) {
                item.style.display = "block";
            }
            else {
                item.style.display = "none";
            }
        });

        let itemBtnClearID = document.getElementById("btnClearID");
        const isHiddenItemBtnClearID = itemBtnClearID.style.display === "none";
        if (isHiddenItemBtnClearID) {
            itemBtnClearID.style.display = "block";
        }
        else {
            itemBtnClearID.style.display = "none";
        }
    };
    const onLoadMessageGetCount = () => {
        let array = []
        array.push({  key: 3, text: 3, title: 3, });
        array.push({  key: 5, text: 5, title: 5 });
        array.push({  key: 10, text: 10, title: 10 });

        return array
    };
    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });
    const _columns = (inputParam_BookList && inputParam_BookList.data === null) ? [] : 
    [
        {
            key: 'all-props-all-props',
            name: t('data-lang-lbl-book'),
            fieldName: 'all-props-all-props',
            minWidth: 180,
            onRender:(item) => {

                const cards = [
                    { class: "col pt-2", title: t('data-lang-lbl-totalmessages'), type: "isTotalMessage", amount: (item.total_send_messages), icon: "CreateMailRule", color: "#a1a1a1", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-receivedmessages'), type: "isReceived", amount: item.received_messages, icon: "Mail", color: "#7FD7A7", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-sendedmessages'), type: "isSent", amount: item.sent_messages, icon: "Send", color: "#A1B8E1", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-unreadedmessages'), type: "isUnread", amount: item.unread_message, icon: "MailAlert", color: "#bdbd63", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-pendingmessages'), type: "isPending", amount: item.pending_messages, icon: "EventDateMissed12", color: "#ffa97f", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-expiredmessages'), type: "isExpired", amount: item.expired_message, icon: "Calories", color: "#FF7F7F", display: true },
            
                    { class: "col pt-2", title: t('data-lang-lbl-pendingwaiting-short'), type: "isPendingWaiting", amount: item.pending_waiting_message, icon: "DateTime", color: "#ffa97f", display: true },
                    { class: "col pt-2", title: t('data-lang-lbl-expiredwaiting-short'), type: "isExpiredWaiting", amount: item.expired_waiting_message, icon: "Clock", color: "#FF7F7F", display: true },
                ];


                return  <>
                            <Row className={`book-status-card-${item.statusId} ms-1 overflow-auto`}>
                                <Col>
                                    <Row>
                                        <Col style={{width: '35%', cursor : "pointer"}} className=" p-1" onClick={() => onViewMessagesClick(item)}>
                                            <TooltipHost
                                                overflowMode={TooltipOverflowMode.Self}
                                                hostClassName={css(classNames.overflow)}
                                                content={
                                                    <div>
                                                        <div>{item.mainBook === true ? t("data-lang-lbl-pdf-mainbook") : t("data-lang-lbl-pdf-auxiliar")}</div>
                                                        <div>{`${t('data-lang-lbl-status')}: ${t('data-lang-sbbook-status' + item.statusId)}`}</div>
                                                    </div>
                                                }
                                                onTooltipToggle={false}
                                                styles={{root: { display: 'block' }}}
                                            >
                                                <Row>
                                                    <Col className="col-auto me-auto pe-0" style={{fontSize: "32px"}}>
                                                            {
                                                                item.mainBook === true ?
                                                                <Icon iconName="AdminPLogoInverse32" />
                                                                :
                                                                <Icon iconName="AdminALogoInverse32" />
                                                            }
                                                    </Col>
                                                    <Col xl={11} className="ps-0">
                                                        <Row>
                                                            <Col style={{whiteSpace: "nowrap"}}>
                                                                <b>{t('data-lang-lbl-code')}:&nbsp;</b>
                                                                { item.bookCode }
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col style={{whiteSpace: "nowrap"}}>
                                                                <b>{t('data-lang-lbl-name')}:&nbsp;</b>
                                                                <TooltipHost content={ item.bookName } overflowMode={TooltipOverflowMode.Parent} >
                                                                    { item.bookName }
                                                                </TooltipHost>
                                                            </Col>
                                                        </Row>
                                                            {
                                                                item.relatedConceptTypeId === 1 ?
                                                                <Row><Col style={{whiteSpace: "nowrap"}}><CLabel labelText={t('data-lang-lbl-project')} labelValue={ item.relatedConceptCode } /> </Col></Row> : <></>
                                                            }
                                                            {
                                                                item.relatedConceptTypeId === 2 ?
                                                                <Row><Col style={{whiteSpace: "nowrap"}}><CLabel labelText={t('data-lang-lbl-contract')} labelValue={ item.relatedConceptCode } /> </Col></Row> : <></>
                                                            }
                                                            {
                                                                item.relatedConceptTypeId === 2 && !isNullOrEmpty(item.contractLegalEntitySupplierName) ?
                                                                <Row><Col style={{whiteSpace: "nowrap"}}>
                                                                    <TooltipHost content={ item.contractLegalEntitySupplierName } overflowMode={TooltipOverflowMode.Parent} >
                                                                        <CLabel labelText={t('data-lang-lbl-legalentitysuppliername')} labelValue={ item.contractLegalEntitySupplierName } />
                                                                    </TooltipHost>
                                                                </Col></Row> : <></>
                                                            }
                                                            {
                                                                item.relatedConceptTypeId === 2 && !isNullOrEmpty(item.contractBusinesUnitName) ?
                                                                <Row><Col style={{whiteSpace: "nowrap"}}>
                                                                    <TooltipHost content={ `${item.contractLegalEntityCode}: ${item.contractBusinesUnitName}` } overflowMode={TooltipOverflowMode.Parent} >
                                                                        <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={ item.contractBusinesUnitName } />
                                                                    </TooltipHost>
                                                                </Col></Row> : <></>
                                                            }
                                                            {
                                                                item.relatedConceptTypeId !== 1 && item.relatedConceptTypeId !== 2 && !isNullOrEmpty(item.managerBusinessUnitName) ?
                                                                <Row><Col style={{whiteSpace: "nowrap"}}>
                                                                    <TooltipHost content={ item.managerBusinessUnitName } overflowMode={TooltipOverflowMode.Parent} >
                                                                        <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={ item.managerBusinessUnitName } />
                                                                    </TooltipHost>
                                                                </Col></Row> : <></>
                                                            }
                                                    </Col>
                                                </Row>                                                            
                                            </TooltipHost>
                                        </Col>
                                        <Col style={{width: '65%'}} className="ms-auto p-1">
                                            <div style={{backgroundColor: "#dadada", height: "55px", width: "fit-content"}} className="d-flex mx-auto">
                                                {
                                                    cards.map((card, index) => (
                                                        card.display &&
                                                        <StadisticCard key={index} item={card} arrayLength={cards.length - cards.filter(x => !x.display).length} index={index+1} />
                                                    ))
                                                }
                                            </div>
                                        </Col>
                                    </Row>                                     
                                </Col>
                            </Row>
                        </>
            }
        },{
            key: 'id',
            name: t('data-lang-lbl-actions'),
            fieldName: 'id',
            minWidth: 90,
            maxWidth: 90,
            styles: {root: {display: "none"}},
            onRender:(item) => {
                return  <Row>
                            <Col style={{cursor : "pointer"}} className="p-1 col-auto mx-auto">
                                <ToolBarDownFall
                                    items={ {
                                        items: [
                                            {
                                                key: 'create',
                                                text: window.location.pathname.toString().toLowerCase().startsWith(__SystemPagesPaths[__enum_SystemPages.BookCreation].text.toLocaleLowerCase()) ? t('data-lang-btn-viewmessages') : t('data-lang-btn-viewbook'),
                                                iconProps: { iconName: 'View' },
                                                onClick: (e) => onViewBookConfig(e, item),
                                            },
                                            {
                                                key: 'viewPartys',
                                                text: t('data-lang-btn-viewpartys'),
                                                iconProps: { iconName: 'AssessmentGroupTemplate' },
                                                onClick: (e) => onViewPartys(e, item),
                                            },
                                            {
                                                key: 'viewSections',
                                                text: t('data-lang-btn-viewsections'),
                                                iconProps: { iconName: 'AssessmentGroup' },
                                                onClick: (e) => onViewSections(e, item),
                                            },
                                            {
                                                key: 'viewUsers',
                                                text: t('data-lang-btn-viewusers'),
                                                iconProps: { iconName: 'Group' },
                                                onClick: (e) => onViewUsers(e, item),
                                            },
                                        ],
                                    } }
                                    display={ true }
                                    mainItem={ { iconName: 'More' } }
                                /> 
                            </Col>
                        </Row>
            }
        }
    ];

    const displayToolBarBook = inputParam_SecurityProps !== null ? inputParam_SecurityProps.isAdmin : false;

    const toolBarItems_Book  = [
        {
            key: 'add',
            text: t('data-lang-btn-create'),
            iconProps: { iconName: 'Add' },
            onClick: onAddBook,
        },
        {
            key: 'viewFilters',
            text: t('data-lang-btn-filter'),
            iconProps: { iconName: 'Filter' },
            style: {display: inputParam_ShowFilterButton ? "block" : "none"},
            onClick: onShowFilters,
        },
    ];

    const onStatusFilterChange = (ev, item) => {
        
        inputParam_SetSelectedStatusFilter && inputParam_SetSelectedStatusFilter(item.key);

    }

    return (
        <Card className='book-party-roles-form h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-boxname-books')}</b>
                    <div className='d-flex'>
                        <div className="my-auto" style={{fontSize: "14px"}}>{t('data-lang-lbl-statusfilter')}&nbsp;&nbsp;</div>
                        {
                            (!(inputParam_BookList && inputParam_BookList.data) || inputParam_ForceSearchParent === true) && 
                            <Dropdown
                                placeholder={t('data-lang-placeholder-selectoption')}
                                options={[{key: "0", text:"Todos"}, {key: "1", text:"Abiertos"}, {key: "2", text:"Cerrados"}]}
                                selectedKey={inputParam_SelectedStatusFilter}
                                disabled={true}
                                styles={ {title: { height: "27px" }} }
                                className="pt-1"
                            />
                        }
                        {
                        ((inputParam_BookList && inputParam_BookList.data) && inputParam_ForceSearchParent === false) && 
                            <Dropdown
                                placeholder={t('data-lang-placeholder-selectoption')}
                                options={[{key: "0", text:"Todos"}, {key: "1", text:"Abiertos"}, {key: "2", text:"Cerrados"}]}
                                selectedKey={inputParam_SelectedStatusFilter}
                                onChange={onStatusFilterChange}
                                styles={ {title: { height: "27px" }} }
                                className="pt-1"
                            />
                        }
                        <div className='book-toolbar'>
                            <ToolBar items={ toolBarItems_Book } styles={{root:{height: "30px"}}} display={ displayToolBarBook } />
                        </div>
                        {
                            false &&
                            <div style={{display: "none"}}>
                                <Dropdown
                                    placeholder={" "}
                                    styles={ {title: { height: "27px"}} }
                                    className="pt-1"
                                    options={onLoadMessageGetCount()}
                                    selectedKey={length}
                                    onChange={onLengthChange}
                                />

                                <ActionButton iconProps={{ iconName: 'SearchAndApps' }} onClick={() => searchMoreItems()} allowDisabledFocus >
                                    { t('data-lang-btn-search') }
                                </ActionButton>
                                <ActionButton id="btnClearID" style={{display: "none"}} iconProps={{ iconName: 'Clear' }} onClick={() => showHideMoreItems()} allowDisabledFocus >
                                    { t('data-lang-btn-clean') }
                                </ActionButton>
                            </div>                            
                        }
                    </div>
                </Card.Title>
            </Card.Header>
            {
                (!(inputParam_BookList && inputParam_BookList.data) || inputParam_ForceSearchParent === true) && 
                <Card.Body className="book-party-roles-form-body h-100">
                    <Row className="h-100">
                        <Col className="d-flex align-items-center justify-content-center">
                            <Loading
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={false}
                                inputParam_Width={'35px'}
                                inputParam_Height={'35px'}
                                inputParam_Left={""}
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ColClassName={"me-2"}
                                inputParam_MarginLeft={"auto"}
                                inputParam_SpinnerSize={SpinnerSize.medium} />
                        </Col>
                    </Row>
                </Card.Body>
            }
            {
                ((inputParam_BookList && inputParam_BookList.data) && inputParam_ForceSearchParent === false) && 
                <>
                    <Card.Body className="book-party-roles-form-body h-100">
                        <Row>
                            <List
                                listLocalStoragePageSizeVariableName="homeBookList"
                                className="no-compact-list big-header"
                                manipulateLocalData={ true }
                                data={ inputParam_BookList !== null ? inputParam_BookList : [] }
                                setData={inputParam_SetBookList}
                                columns={_columns} 
                                enableExport={ true }
                                handleExport={ handleExport }
                                exportFileName={"Listado de libros.xlsx"}
                            />
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="homeBookList" 
                            data={ inputParam_BookList !== null ? inputParam_BookList : [] }
                            setData={inputParam_SetBookList} />
                    </Card.Footer>
                </>
            }

            {
                !isNullOrEmpty(objBookSelectedToOptions) &&
                <>
                    {
                        isPanelViewSectionsOpen &&
                        <SidePanelSections bookObject={ objBookSelectedToOptions } isPanelOpen={ isPanelViewSectionsOpen } setterIsPanelOpen={ setIsPanelViewSectionsOpen } editMode={false} />
                    }
                    {
                        isPanelViewPartysOpen &&
                        <SidePanelPartys bookObject={ objBookSelectedToOptions } isPanelOpen={ isPanelViewPartysOpen } setterIsPanelOpen={ setIsPanelViewPartysOpen } />
                    }
                    {
                        isPanelViewUsersOpen &&
                        <SidePanelViewUsers bookId={ objBookSelectedToOptions.id } isPanelOpen={ isPanelViewUsersOpen } setterIsPanelOpen={ setIsPanelViewUsersOpen } getBookList={true} />
                    }
                </>
            }
        </Card>
    );
}

export default HomeBookListBox;

